// Карта slug игры → путь к иконке
export const GAME_ICONS = {
  cs2: '/images/games/cs2.svg',
  dota2: '/images/games/dota2.svg',
  rust: '/images/games/rust.svg'
}

// Получить путь к иконке по slug игры
export const getGameIcon = (slug) => {
  if (!slug || typeof slug !== 'string') return null
  return GAME_ICONS[slug] || null
}
